var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isInIframe)?_c('CookieConsent',_vm._b({},'CookieConsent',_vm.$props,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }